module.exports = __webpack_public_path__ + "static/media/f0_4.b3fe6c1f.png";